export default class Slider {
  constructor(name, options, paginationType) {
    this.name = name;
    this.options = options;
    this.paginationType = paginationType;
  }

  init() {
    if (!$(".js-swiper-" + this.name).length) {
      return
    }

    let defaultOptions = {
      watchOverflow: true,
      watchSlidesVisibility: true,
      speed: 500,
      threshold: 40,
      loop: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.js-swiper-pagination-' + this.name,
        type: this.paginationType || 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.js-swiper-next-' + this.name,
        prevEl: '.js-swiper-prev-' + this.name
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      slideToClickedSlide: false,
      on: {
        init: function () {
          let totalSlides = this.params.loop ? this.slides.length - 2 : this.slides.length;
          let self = this;

          if(totalSlides <= this.params.slidesPerView) {
            $(this.$el).removeClass('cursor-grab');
            $(this.$el).addClass('swiper-disabled');

            this.params.loop = false;
            this.params.pagination = {};
            this.params.navigation = {};
            this.params.autoplay = {};
            this.params.noSwiping = true;
            this.params.noSwipingClass = 'swiper-slide';
          }

          window.onload = function() {
            self.update();
          };
        },

        slideChange: function() {
          let $anims = this.$el.find("[data-anim]");

          $anims.each(function(i, animEl) {
            $(animEl).removeAttr( 'style' );
          });
        }
      }
    };

    return new Swiper(".js-swiper-" + this.name, Object.assign(defaultOptions, this.options));
  }
}


// WEBPACK FOOTER //
// ./static/js/components/Slider.js